<app-navbar></app-navbar>
<div *ngIf="ckies" class="cookies">
    <div class="card" style="width: 18rem;">
        <div class="text-right">
            <button (click)="closeCookiesCard()" style="color: #fff;" type="button" class="close mr-2" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
        </div>
        <div class="card-body">
            <p class="card-text">Esta web usa cookies para ofrecerle una mejor experiencia. <a href="" data-toggle="modal" data-target="#cookies">Saber más</a></p>
            <div class="text-center">
                <button (click)="closeCookiesCard()" class="btn btn-light">Estoy de acuerdo</button>
            </div>
        </div>
    </div>
</div>

<section>
    <div class="slideBox d-none d-lg-block d-xl-block animated fadeIn">
        <div id="carouselExampleCaptions" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
                <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
                <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
                <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
                <li data-target="#carouselExampleCaptions" data-slide-to="3"></li>
            </ol>
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src="../../../assets/img/slider/slide1.jpg" class="d-block w-100" alt="...">
                    <div class="carousel-caption d-none d-md-block">
                        <h2>Pensamos en tu bienestar</h2>
                        <h4>Somos fuente de salud y belleza</h4>
                    </div>
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/slider/slide2.jpg" class="d-block w-100" alt="...">
                    <div class="carousel-caption d-none d-md-block">
                        <h2>Te ayudamos a sentirte mejor</h2>
                        <h4>Brindándote soluciones cuando mas lo necesites</h4>
                    </div>
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/slider/slide3.jpg" class="d-block w-100" alt="...">
                    <div class="carousel-caption d-none d-md-block">
                        <h2>Cuidamos a las familias</h2>
                        <h4>Fomentamos calidad de vida para ti y los que más amas</h4>
                    </div>
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/slider/slide4.jpg" class="d-block w-100" alt="...">
                    <div class="carousel-caption d-none d-md-block ltr">
                        <h2>Hacemos vidas más saludables</h2>
                        <h4>Aprovechamos las bondades de la naturaleza</h4>
                    </div>
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
    <div class="d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src="../../../assets/img/slider/slide1.jpg" class="d-block w-100" alt="...">
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/slider/slide2.jpg" class="d-block w-100" alt="...">
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/slider/slide3.jpg" class="d-block w-100" alt="...">
                </div>
                <div class="carousel-item">
                    <img src="../../../assets/img/slider/slide4.jpg" class="d-block w-100" alt="...">
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</section>
<section>
    <div class="blue"> </div>
    <div class="title d-none d-lg-block d-xl-block">
        <div class="col-md-12">
            <div class="card-group">
                <div class="card">
                    <div class="card-body">
                        <hr class="line">
                    </div>
                </div>
                <div class="card">
                    <div class="card-body text-center">
                        <h2 class="ltTitle">NUESTROS PRODUCTOS</h2>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <hr class="line">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="title d-xs-block d-sm-block d-md-none d-lg-none d-xl-none">
        <div class="col-md-12">
            <div class="card-group">
                <div class="card">
                    <div class="card-body text-center">
                        <hr class="line">
                        <h2 class="ltTitle">NUESTROS PRODUCTOS</h2>
                        <hr class="line">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="col-md-12 text-center d-none d-lg-block d-xl-block">
            <h5>¡Que la compra de nuestros productos sea un acto de amor, para que te</h5>
            <h5>cuides a ti mismo de ahora en adelante!</h5>
        </div>
        <div class="col-md-12 text-center d-xs-block d-sm-block d-md-none d-lg-none d-xl-none">
          <h5>¡Que la compra de nuestros productos sea un acto de amor, para que te cuides a ti mismo de ahora en adelante!</h5>
      </div>
    </div>

    <div class="productos">
        <div class="container">
            <div class="col-md-12 mt-5 "><br>
                <div class="row row-cols-1 row-cols-md-3">
                    <div class="col mb-4" *ngFor="let item of cat">
                        <div class="card cate" (click)="openCategories(item.nombre)">
                            <img [src]="item.imagen" class="card-img-top" alt="...">
                            <h4 class="card-title text-center">{{item.portada}}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center">
                    <button [routerLink]="['/categorias']" routerLinkActive="router-link-active" class="btn btn-light btnPer">VER MÁS</button>
                </div>
            </div>
        </div>
    </div>
    <div class="seccion d-none d-lg-block d-xl-block">
        <div class="container">
            <div class="col-md-12 text-center"><br><br><br><br><br>
                <h2 class="tdpro">ÚLTIMAS PUBLICACIONES</h2><br>
                <h5>Es importante para nosotros que estes saludable física y mentalmente para que puedas sacar tu</h5>
                <h5>máximo potencial, por tal motivo, creamos contenido de valor para ti de salud, belleza y</h5>
                <h5>bienestar.</h5>
            </div>
        </div>
    </div>
    <div class="seccion d-none d-md-block d-lg-none d-xl-none">
        <div class="container">
            <div class="col-md-12 text-center"><br><br><br><br>
                <h2 class="tdpro">ÚLTIMAS PUBLICACIONES</h2><br>
                <h5>Es importante para nosotros que estes saludable física y mentalmente para que puedas sacar tu</h5>
                <h5>máximo potencial, por tal motivo, creamos contenido de valor para ti de salud, belleza y</h5>
                <h5>bienestar.</h5>
            </div>
        </div>
    </div>
    <div class="seccion d-xs-block d-sm-block d-md-none d-lg-none d-xl-none">
        <div class="container">
            <div class="col-md-12 text-center"><br><br>
                <h2 class="tdpro">ÚLTIMAS PUBLICACIONES</h2>
                <h5>Es importante para nosotros que estes saludable física y mentalmente para que puedas sacar tu máximo potencial, por tal motivo, creamos contenido de valor para ti de salud, belleza y bienestar.</h5>
            </div>
        </div>
    </div>
    <br><br><br>
    <div class="publicaciones">
        <div class="container">
            <div class="col-md-12"><br><br><br><br><br><br>
                <!--Carousel Wrapper-->
                <div id="multi-item-example" class="carousel slide carousel-multi-item" data-ride="carousel">

                    <!--Controls-->
                    <div class="controls-top">
                        <a class="btn-floating float-left" href="#multi-item-example" data-slide="prev"><i class="fa fa-chevron-left"></i></a>
                        <a class="btn-floating float-right" href="#multi-item-example" data-slide="next"><i class="fa fa-chevron-right"></i></a>
                    </div>
                    <!--/.Controls-->
                    <!--Slides-->
                    <div class="carousel-inner" role="listbox">

                        <!--First slide-->
                        <div class="carousel-item active">

                          <div class="row row-cols-1 row-cols-md-4">
                            <div class="col mb-4">
                              <div class="card h-100">
                                 <img *ngIf="blogs[0].video != 'Si'" class="card-img-top" [src]="blogs[0].imagen" alt="Card image cap">
                                 <img *ngIf="blogs[0].video == 'Si'" class="card-img-top" src="../../../../assets/img/FOTO-BLOG.png" alt="Card image cap">
                                <div class="card-body">
                                  <h5 class="card-title">{{blogs[0].titulo}}</h5>
                                  <div class="card-footer">
                                     <button class="btn btn-outline-primary btn-block" data-toggle="modal" data-target="#exampleModal" (click)="detallePost(blogs[0])">Ver post</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col mb-4">
                              <div class="card h-100">
                                 <img *ngIf="blogs[1].video != 'Si'" class="card-img-top" [src]="blogs[1].imagen" alt="Card image cap">
                                 <img *ngIf="blogs[1].video == 'Si'" class="card-img-top" src="../../../../assets/img/FOTO-BLOG.png" alt="Card image cap">
                                <div class="card-body">
                                  <h5 class="card-title">{{blogs[1].titulo}}</h5>
                                  <div class="card-footer">
                                     <button class="btn btn-outline-primary btn-block" data-toggle="modal" data-target="#exampleModal" (click)="detallePost(blogs[1])">Ver post</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col mb-4">
                              <div class="card h-100">
                                 <img *ngIf="blogs[2].video != 'Si'" class="card-img-top" [src]="blogs[2].imagen" alt="Card image cap">
                                 <img *ngIf="blogs[2].video == 'Si'" class="card-img-top" src="../../../../assets/img/FOTO-BLOG.png" alt="Card image cap">
                                <div class="card-body">
                                  <h5 class="card-title">{{blogs[2].titulo}}</h5>
                                  <div class="card-footer">
                                     <button class="btn btn-outline-primary btn-block" data-toggle="modal" data-target="#exampleModal" (click)="detallePost(blogs[2])">Ver post</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col mb-4">
                              <div class="card h-100">
                                <img *ngIf="blogs[3].video != 'Si'" class="card-img-top" [src]="blogs[3].imagen" alt="Card image cap">
                                <img *ngIf="blogs[3].video == 'Si'" class="card-img-top" src="../../../../assets/img/FOTO-BLOG.png" alt="Card image cap">
                                <div class="card-body">
                                  <h5 class="card-title">{{blogs[3].titulo}}</h5>
                                  <div class="card-footer">
                                     <button class="btn btn-outline-primary btn-block" data-toggle="modal" data-target="#exampleModal" (click)="detallePost(blogs[3])">Ver post</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!--/.First slide-->

                        <!--Second slide-->
                        <div class="carousel-item">

                          <div class="row row-cols-1 row-cols-md-4">
                            <div class="col mb-4">
                              <div class="card h-100">
                                 <img *ngIf="blogs[4].video != 'Si'" class="card-img-top" [src]="blogs[4].imagen" alt="Card image cap">
                                 <img *ngIf="blogs[4].video == 'Si'" class="card-img-top" src="../../../assets/img/FOTO-BLOG.png" alt="Card image cap">
                                <div class="card-body">
                                  <h5 class="card-title">{{blogs[4].titulo}}</h5>
                                  <div class="card-footer">
                                     <button class="btn btn-outline-primary btn-block" data-toggle="modal" data-target="#exampleModal" (click)="detallePost(blogs[4])">Ver post</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col mb-4">
                              <div class="card h-100">
                                 <img *ngIf="blogs[5].video != 'Si'" class="card-img-top" [src]="blogs[5].imagen" alt="Card image cap">
                                 <img *ngIf="blogs[5].video == 'Si'" class="card-img-top" src="../../../../assets/img/FOTO-BLOG.png" alt="Card image cap">
                                <div class="card-body">
                                  <h5 class="card-title">{{blogs[5].titulo}}</h5>
                                  <div class="card-footer">
                                     <button class="btn btn-outline-primary btn-block" data-toggle="modal" data-target="#exampleModal" (click)="detallePost(blogs[5])">Ver post</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col mb-4">
                              <div class="card h-100">
                                 <img *ngIf="blogs[6].video != 'Si'" class="card-img-top" [src]="blogs[6].imagen" alt="Card image cap">
                                 <img *ngIf="blogs[6].video == 'Si'" class="card-img-top" src="../../../../assets/img/FOTO-BLOG.png" alt="Card image cap">
                                <div class="card-body">
                                  <h5 class="card-title">{{blogs[6].titulo}}</h5>
                                  <div class="card-footer">
                                     <button class="btn btn-outline-primary btn-block" data-toggle="modal" data-target="#exampleModal" (click)="detallePost(blogs[6])">Ver post</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col mb-4">
                              <div class="card h-100">
                                <img *ngIf="blogs[7].video != 'Si'" class="card-img-top" [src]="blogs[7].imagen" alt="Card image cap">
                                <img *ngIf="blogs[7].video == 'Si'" class="card-img-top" src="../../../../assets/img/FOTO-BLOG.png" alt="Card image cap">
                                <div class="card-body">
                                  <h5 class="card-title">{{blogs[7].titulo}}</h5>
                                  <div class="card-footer">
                                     <button class="btn btn-outline-primary btn-block" data-toggle="modal" data-target="#exampleModal" (click)="detallePost(blogs[7])">Ver post</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--/.Second slide-->
                    </div>
                    <!--/.Slides-->
                </div>
                <!--/.Carousel Wrapper-->
            </div>
        </div>
        <br>
    </div>
</section>
<section class="suscripcion">
    <div class="container">
        <div class="col-sm-12">
            <div class="row">
                <div class="col-sm-6">
                    <div class="card msg">
                        <div class="card-body">
                            <h5 class="card-title"><b>DÉJANOS TU CORREO</b></h5>
                            <p class="card-text">No te pierdas las novedades y el contenido para cuidarte a ti y a los que más amas.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 d-none d-lg-block d-xl-block">
                    <div class="card suscr mt-3">
                        <div class="card-body">
                            <form class="form-inline" [formGroup]="subscriptionForm" (ngSubmit)="subscription(subscriptionForm.value)">
                                <input class="form-control susc" type="text" placeholder="Ingresa tu correo" formControlName="email" aria-label="Search">
                                <button class="btn btn-warning btnPer" type="submit">SUSCRÍBETE</button>
                                <small class="eml" *ngIf="emailNoValido">Ingrese un email válido</small>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
                    <div class="card suscr mt-3">
                        <div class="card-body">
                            <form class="form-inline" [formGroup]="subscriptionForm" (ngSubmit)="subscription(subscriptionForm.value)">
                                <input class="form-control" type="text" placeholder="Ingresa tu correo" formControlName="email" aria-label="Search">
                                <div class="text-center scbrte mt-2">
                                    <button class="btn btn-warning btnPer" type="submit">SUSCRÍBETE</button>
                                </div>
                                <small class="eml" *ngIf="emailNoValido">Ingrese un email válido</small>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="contacto">
    <div class="ctn">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 mt-5" id="contacto">
                    <div class="row">
                        <div class="col-sm-6 mt-5">
                            <div class="card info">
                                <div class="card-body mt-5 ml-5 mb-5">
                                    <h5 class="card-title"><b>CONTACTO</b></h5>
                                    <p class="card-text"><b>Tienda Online Torreón Market</b></p>
                                    <p class="card-text"><b>Teléfono 323 4902185. Colombia</b></p>
                                    <p class="card-text"><b>torreonmarket.info@gmail.com</b></p>
                                    <p class="card-text"><b>Whatsapp 323 4902185</b></p>
                                    <p class="card-text"><b>Redes sociales:</b>
                                        <button class="redes"><a href="https://www.facebook.com/torreonmarket.colombia" target="blank"><i class="fa fa-facebook fa-lg" aria-hidden="true"></i></a></button>
                                        <button class="redes"><a href="https://www.youtube.com/channel/UCMhrKPXZXlqmfUKSyXMIlsw" target="blank"><i class="fa fa-youtube fa-lg" aria-hidden="true"></i></a></button>
                                        <button class="redes"><a href="https://twitter.com/torreonmarket" target="blank"><i class="fa fa-twitter fa-lg" aria-hidden="true"></i></a></button>
                                        <button class="redes"><a href="https://www.instagram.com/torreon.market" target="blank"><i class="fa fa-instagram fa-lg" aria-hidden="true"></i></a></button>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <div class="card frml">
                                <div class="card-body">
                                    <form [formGroup]="contactForm" (ngSubmit)="message(contactForm.value)">
                                        <div class="col-lg-12 mt-4">
                                            <label for="">Nombre</label>
                                            <input type="text" class="form-control" formControlName="nombre">
                                        </div>
                                        <div class="col-lg-12">
                                            <label for="">Correo</label>
                                            <input type="text" class="form-control" formControlName="correo">
                                        </div>
                                        <div class="col-lg-12">
                                            <label for="">Teléfono</label>
                                            <input type="text" class="form-control" formControlName="telefono">
                                        </div>
                                        <div class="col-lg-12">
                                            <label for="">Ciudad</label>
                                            <input type="text" class="form-control" formControlName="ciudad">
                                        </div>
                                        <div class="col-lg-12">
                                            <label for="">Mensaje</label>
                                            <textarea class="form-control area" name="msj" id="" cols="30" rows="3" formControlName="mensaje"></textarea>
                                        </div>
                                        <div class="col-lg-12 text-right">
                                            <button type="submit" class="btn btn-ligh btnPer mt-1"> ENVIAR </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="endPage">
    <div class="container">
        <div class="col-lg-12">
            <div class="row row-cols-1 row-cols-md-5 mt-5">
                <div class="col mb-4">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <img src="../../../assets/img/footer/credit-card.png" class="img-fluid" alt="Responsive image" width="50%">
                            <h5 class="card-title">Pago con tarjeta o efectivo</h5><br>
                        </div>
                    </div>
                </div>
                <div class="col mb-4">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <img src="../../../assets/img/footer/several-pack.png" class="img-fluid" alt="Responsive image" width="50%">
                            <h5 class="card-title">Se hace envíos a toda Colombia</h5>
                        </div>
                    </div>
                </div>
                <div class="col mb-4">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <img src="../../../assets/img/footer/tracking.png" class="img-fluid" alt="Responsive image" width="50%">
                            <h5 class="card-title">Envío gratis desde $90.000 en Pereira</h5>
                        </div>
                    </div>
                </div>
                <div class="col mb-4">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <img src="../../../assets/img/footer/shield.png" class="img-fluid" alt="Responsive image" width="50%">
                            <h5 class="card-title">Seguridad de principio a fin</h5><br>
                        </div>
                    </div>
                </div>
                <div class="col mb-4">
                    <div class="card h-100">
                        <div class="card-body text-center">
                            <img src="../../../assets/img/footer/quality.png" class="img-fluid" alt="Responsive image" width="50%">
                            <h5 class="card-title">Productos de calidad</h5><br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>

<!-- Modal -->
<div class="modal fade" id="cookies" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center" id="exampleModalLabel" style="color: #6C534C; font-weight: bold;">Cookies y/o Tecnologías muy similares</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body" style="background-color: #fff;">
                <p>
                    Para entender de una mejor manera las necesidades de los usuarios y entregar un mejor servicio, este sitio utiliza identificadores anónimos cookies y/o tecnologías similares para recoger información anónima de preferencias e intereses de sus usuarios.
                    Una cookie o tecnología similar es cualquier cadena de texto que pide autorización para alojarse en el disco duro de la computadora. Si el usuario acepta, entonces el explorador agrega el texto en un archivo pequeño con la finalidad
                    de notificarnos cuando el usuario visita nuestro sitio web.
                </p>
                <p>
                    La información recogida por este medio se proporciona a compañías asociadas y es utilizada por estas para crear perfiles anónimos para cualquier propósito, incluyendo, más no limitado a, desarrollar, fabricar y comercializar productos, y puede ser comercializada,
                    diseminada o usada por Karen Yisell Cortés Gómez (TORREÓN MARKET), o sus afiliados. La información proporcionada a tales compañías no incluye y nunca se combina con datos de carácter personal que permitan identificar a una persona determinada
                    (tal como nombre, domicilio o dirección de correo electrónico) o cualquier información que pueda ser considerada sensible o que pueda comprometer la privacidad de los usuarios.
                </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="blogdetail" class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Detalle del artículo</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
          </div>
          <div class="modal-body" style="background-color: #fff;">
              <div class="card mb-3">
                <div *ngIf="blogdetail.video == 'Si'" class="text-center">
                  <iframe width="560" height="315" [src]="getVideoIframe(blogdetail.imagen)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                  <img *ngIf="blogdetail.video == 'No'" [src]="blogdetail.imagen" class="card-img-top" alt="...">
                  <div class="card-body">
                      <h5 class="card-title">{{blogdetail.titulo }}</h5>
                      <p *ngFor="let item of blogdetail.contenido" class="card-text">{{item}}</p>
                      <div class="col-lg-12">
                          <h5>Comentarios</h5>
                          <hr>
                          <div *ngFor="let item of blogdetail.comentarios">
                            <small>{{item.fecha | date}}</small>
                            <p>{{item.autor}}</p>
                            <p>{{item.comentario}}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
      </div>
  </div>
</div>

